import { useMemo } from 'react';

import useSearchAlternated from './useSearchAlternated';

/**
 * Hook to fetch entity first/last seen dates from O_ENTITIES
 * @param {Object} params
 * @param {string} params.entity - Entity to search for
 * @param {boolean} [params.enabled=true] - Whether to enable the query
 * @returns {Object} - Returns loading, error, sensorData array, and hasSensorData boolean
 */
const useEntityFirstLastSeen = ({ entity, enabled = true }) => {
  const pqlQuery = enabled && entity ? `last 90 days entity = "${entity}"` : undefined;

  const { loading, results, error } = useSearchAlternated({
    pqlQuery,
    pqlAlternation: '| include first_observed, last_observed, sensorId, sensorName',
    searchType: 'O_ENTITIES',
    context: undefined,
    registryGroupKey: undefined,
    skipRegistry: true,
    transformResponse: undefined,
    onSearchSuccess: undefined,
    onSearchFail: undefined,
  });

  // Group results by sensor and get min first_observed and max last_observed
  const sensorData = useMemo(() => {
    if (!results?.length) {
      return [];
    }

    return results.map((result) => ({
      sensorId: result.sensorId,
      sensorName: result.sensorName,
      firstObserved: result.first_observed,
      lastObserved: result.last_observed,
    }));
  }, [results]);

  return {
    loading,
    error,
    sensorData,
    hasSensorData: sensorData.length > 0,
  };
};

export default useEntityFirstLastSeen;
